export default __webpack_public_path__ + "static/media/doc5.ffc7074e.jpeg";